import { ImportAddStepsAction, ImportAddStepsActions } from "../actions";
import { AccessPointProcessingGroup, License } from "../models";
import { ImportAddGroupState, ImportAddStepsState, ImportAddStepState } from "../state";

export const importAddStepsInitialState: ImportAddStepsState = Object.freeze({
  availableGroups: {},
  display: false,
  isLoading: true,
  licenseTypes: [],
  selectedLicense: License.Any,
});

export const importAddStepsReducer = (state: ImportAddStepsState, action: ImportAddStepsActions): ImportAddStepsState => {
  switch (action.type) {
    case ImportAddStepsAction.AddStepsPanelDisplay:
      return Object.freeze({
        ...state,
        display: action.display,
      });
    case ImportAddStepsAction.ClearSelected:
      return Object.freeze({
        ...state,
        availableGroups: (Object.keys(state.availableGroups) as AccessPointProcessingGroup[]).reduce((acc, key) => {
          acc[key] = {
            ...state.availableGroups[key],
            selected: false,
          };
          return acc;
        }, {} as { [group: string]: ImportAddGroupState }),
      });
    case ImportAddStepsAction.GroupSelected:
      return Object.freeze({
        ...state,
        availableGroups: {
          ...state.availableGroups,
          [action.group]: {
            ...state.availableGroups[action.group],
            selected: !state.availableGroups[action.group].selected,
          },
        },
      });
    case ImportAddStepsAction.LicenseFilterChanged:
      return Object.freeze({
        ...state,
        selectedLicense: action.license,
      });
    case ImportAddStepsAction.LoadAvailableSteps:
      return Object.freeze({
        ...state,
        availableGroups: {},
        isLoading: true,
      });
    case ImportAddStepsAction.LoadAvailableStepsSuccess:
      return Object.freeze({
        ...state,
        availableGroups: action.result.reduce((groupAcc, group) => {
          groupAcc[group.groupType] = {
            name: group.name,
            selected: false,
            steps: group.steps.reduce((stepAcc, step) => {
              stepAcc[step.stepType] = {
                licenseTypes: step.licenseTypes,
                name: step.name,
              };
              return stepAcc;
            }, {} as { [step: string]: ImportAddStepState }),
          };
          return groupAcc;
        }, {} as { [group: string]: ImportAddGroupState }),
        isLoading: false,
      });
    case ImportAddStepsAction.LoadAvailableStepsFailure:
      return Object.freeze({
        ...state,
        isLoading: false,
      });
    case ImportAddStepsAction.LoadLicenseTypes:
      return Object.freeze({
        ...state,
        licenseTypes: [],
      });
    case ImportAddStepsAction.LoadLicenseTypesSuccess:
      return Object.freeze({
        ...state,
        licenseTypes: action.result,
      });
    case ImportAddStepsAction.LoadAvailableStepsFailure:
      return Object.freeze({
        ...state,
        error: action.error,
      });
    default:
      throw new Error(`Action ${JSON.stringify(action)} not handled in importAddStepsReducer`);
  }
};
